import { render, staticRenderFns } from "./setRole.vue?vue&type=template&id=926cdf80&"
import script from "./setRole.vue?vue&type=script&lang=js&"
export * from "./setRole.vue?vue&type=script&lang=js&"
import style0 from "./setRole.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports